import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Advocate_INFJ_personality_header from '../../images/personality_types_details/diplomats_Advocate_INFJ_personality_header.svg'
import diplomats_Advocate_INFJ_career_path from '../../images/personality_types_details/diplomats_Advocate_INFJ_career_path.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const infj_careers = () => {
    return (
        <Layout>
            <main className="q-td analyst advocate">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/advocate-infj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-careers" className="tab with-progress active">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/advocate-infj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat advocate">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Advocate_INFJ_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Advocate</span> Personality</h1>
                        <div class="code">INFJ-A / INFJ-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>

                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/advocate-infj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-parents">Parenthood</Link></li>
                                <li className="active"><Link to="/personality-types/advocate-infj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/advocate-infj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article className="main description">

                        <h1>Career Paths</h1>


                        <blockquote><p>“It’s better to fail while striving for something wonderful, challenging, adventurous, and uncertain, than to say, ’I don’t want to try because I may not succeed completely.’”</p> <footer>Jimmy Carter</footer></blockquote>

                        <p>Advocates (INFJs) tend to seek a career path that aligns with their values rather than one that offers status and material gain. Fortunately, people with this personality type are able to find work that suits them in just about any field.</p>

                        <p>In fact, many Advocates have trouble deciding which job is best for them because they’re able to imagine so many possibilities. These personalities may see 10 wildly different paths forward, each with its own set of rewards. This can be exciting but also stress-inducing, because picking just one means letting go of so many others.</p>

                        <h2>Truth, Beauty, Purpose</h2>

                        <p>Advocates want to find meaning in their work and to know that they are helping and connecting with people. This desire to help and connect can make roles as counselors, psychologists, teachers, social workers, yoga instructors, and spiritual leaders very rewarding for Advocates. Careers in health care – especially the more holistic varieties – can also be attractive options for this personality type.</p>

                        <div className="scene"><img alt="Advocate (INFJ) careers" src={diplomats_Advocate_INFJ_career_path} /></div>

                        <p>Many Advocates are also strong communicators. This explains why they are often drawn to careers in writing, authoring many popular books, blogs, stories, and screenplays. Music, photography, design, and art can all be viable options as well, allowing Advocates to focus on deeper themes of personal growth and purpose.</p>

                        <p>That said, Advocates can excel in a range of fields. Wherever they work, people with this personality type can find ways to help others. They can also find ways to use their creativity in nearly any position. No matter what it says on their business cards, Advocates’ insight can enable them to spot unusual patterns and come up with out-of-the-box solutions, creating real change in others’ lives.</p>

                        <div className="description-pullout">
                            For Advocates, money and Employee of the Month simply won’t cut it. These personalities want a career that fits their values and principles.
                       </div>

                        <h2>Two Roads Diverged in a Yellow Wood</h2>

                        <p>Advocates’ needs may be hard to meet in some work environments, especially those that offer little independence and agency. Advocate personalities are sometimes drawn to behind-the-scenes and noncompetitive roles, but these jobs can lead to frustration if they don’t allow Advocates to act as they see fit, grow as individuals, and make a difference.</p>

                        <p>For this reason, people with the Advocate personality type may feel fulfilled by seeking out leadership positions or by starting their own business. By finding jobs that offer more autonomy, Advocates can focus on applying their creativity and integrity to everything they do. Advocates may also find it gratifying to create bridges between seemingly disparate professional fields – for example, by writing about psychology or by being an environmental lawyer. These hybrid careers can offer plenty of opportunities for Advocates to exercise their creativity and their love of learning.</p>

                        <p>Where Advocates struggle is in work that doesn’t take personal needs into consideration, is overly repetitious, or promotes conflict. Jobs with these characteristics can leave Advocates frustrated and unfulfilled. People with this personality type may also chafe at the criticism and pressure that come with cutthroat, competitive work environments.</p>

                        <h2>A Sense of Mission</h2>

                        <p>In truth, Advocate personalities can do well in any field. To be truly happy, however, they need to find work that aligns with their values and allows them some independence. Advocates crave opportunities to learn and grow alongside the people they are helping. When this happens, Advocates may finally feel as if they are fulfilling their life’s mission, contributing to the well-being of humanity on a personal level.</p>

                        <div className="number">06</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/advocate-infj-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/advocate-infjs-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default infj_careers
